import(/* webpackMode: "eager" */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\src\\app\\[locale]\\midia\\page.tsx");
